import { IconButton ,TooltipHost} from '@fluentui/react';
import React, { useContext } from 'react';
import "./styles/ModalHeaderCss.css";
import themeContext from '../../context/theme/ThemeContext';
import CustomToolTipHost from '../CustomToolTipHost/CustomToolTipHost';

const ModalHeader = (props) => {

  const { getThemeColor } = useContext(themeContext);
  const isViewer = false;

  const iconButtonStyles = {
    icon: {color: getThemeColor("primary-color"), border:"none",outline:"none"},
    root: {
      backgroundColor: 'transparent',
      selectors: {
        ':hover .ms-Button-icon': {
          color: 'white'
        },
    },
  },
    rootHovered: {backgroundColor: 'transparent'},
    rootPressed: {backgroundColor: 'transparent'}
  };


  return (
    <>
      {props.updatedModal == undefined || props.updatedModal == null ?  <div className='modal-header-container'>
            <div className='modal-header-patient-details'>
            {props.showPatientDetails && 
              <>  <CustomToolTipHost content={"Patient Name: "+props.patientName} id={"tooltip_"}>
                <h1 className='modal-header-patientName'>{props.patientName}</h1></CustomToolTipHost>
                <CustomToolTipHost content={"Patient Name: "+props.patientID} id={"tooltip_"}>
                <h1 className='modal-header-id-label'>ID {props.patientID}</h1></CustomToolTipHost>
                </>
            }
            </div>
            <div className="modal-header-heading">{props.heading}</div>
            <div className="modal-header-crossicon">
            {!(props.hideCancelIcon == undefined || props.hideCancelIcon == null) ? !props.hideCancelIcon : true && <IconButton
            iconProps = {{iconName: 'Cancel'}}
            styles={iconButtonStyles}
            ariaLabel="Close popup modal"
            onClick={props.handleCancel}
            // style={{border:"none",outline:"none",color:"#FFFFFF",border:"1px solid white"}}
            className='modal-header-crossicon-button'
            />}
            </div>
        </div> : 
        <div className='modal-header-container-updated' style={{background: !isViewer ? getThemeColor("modal-header-footer") : "#222"}}>
            <div style={{color: getThemeColor("primary-color")}} className="modal-header-heading-updated">{props.heading}</div>
            <div className="modal-header-crossicon">
            {!(props.hideCancelIcon == undefined || props.hideCancelIcon == null) ? !props.hideCancelIcon : true && <IconButton
             styles={iconButtonStyles}
            iconProps = {{iconName: 'Cancel'}}
            ariaLabel="Close popup modal"
            onClick={props.handleCancel}
            // style={{border:"none",outline:"none",color:"#FFFFFF",border:"1px solid white"}}
            className='modal-header-crossicon-button'
            />}
            </div>
        </div>}
    </>
  )
}

export default ModalHeader;

export const iconButtonStyles = {
  icon: {color:"#C4C4C4",border:"none",outline:"none"},
  root: {
    backgroundColor: 'transparent',
    selectors: {
      ':hover .ms-Button-icon': {
        color: 'white'
      },
  },
},
  rootHovered: {backgroundColor: 'transparent'},
  rootPressed: {backgroundColor: 'transparent'}
};

export const iconButtonStylesFunc = (getThemeColor) => {
  return {
    icon: { color: getThemeColor("primary-color"), border: "none", outline: "none" },
    root: {
      backgroundColor: "transparent",
      selectors: {
        ":hover .ms-Button-icon": {
          color: "white",
        },
      },
    },
    rootHovered: { backgroundColor: "transparent" },
    rootPressed: { backgroundColor: "transparent" },
  };
};
  